import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import pSBC from 'shade-blend-color';
// import colors from 'vuetify/lib/util/colors';

// Definition of the theme colors
const ligthRatio = 0.3;
const primary = '#009DE9'; /* indigo */
const warning = '#E07602'; /* jaune */
const error = '#CC0033'; /* rouge */
const lightColors = {
  primary,
  secondary: '#1F106D' /* bleu  */,
  accent: '#003b70' /* deep blue */,
  error,
  lighterror: pSBC(ligthRatio, error),
  info: '#0B74C0' /* cyan */,
  success: '#009934' /* vert */,
  warning,
  lightwarning: pSBC(ligthRatio, warning),
  'red-mandy': '#E74A50',
  'blue-venice': '#005288',
  'violet-eggplant': '#910F7D',
  'text-background': '#E8F5E9',
  background: '#f2f2f2',
  secondarybackground: '#ffffff',
  grey: '#9E9E9E',
  main: '#000000',
  lightgrey: '#BDBDBD',
  lightprimary: pSBC(ligthRatio, primary),
  opposite: '#FFFFFF',
  purple: '#8E24AA',
  orange: '#F07D00',
};

const primaryD = '#039BE5'; /* indigo */
const warningD = '#E76D39'; /* orange */
const errorD = '#F25A69'; /* indigo */
const darkColors = {
  primary: primaryD,
  secondary: '#907EEC' /* rose  */,
  accent: '#536DFE' /* deep blue */,
  error: errorD /* rouge */,
  lighterror: pSBC(ligthRatio, errorD),
  info: '#63ADD5' /* cyan */,
  success: '#32B760' /* vert */,
  warning: warningD,
  lightwarning: pSBC(ligthRatio, warningD),
  'red-mandy': '#EE8185',
  'blue-venice': '#538AAE',
  'violet-eggplant': '#F06BDB',
  'text-background': '#424242',
  background: '#0f1e29',
  secondarybackground: '#142938',
  grey: '#757575',
  main: '#FFFFFF',
  lightgrey: '#616161',
  opposite: '#000000',
  lightprimary: pSBC(ligthRatio, primaryD),
  purple: '#D81B60',
  orange: '#F07D00',
};

Vue.use(Vuetify);

const opts = {
  breakpoint: {
    mobileBreakpoint: 'xs', // This is equivalent to a value of 960
  },
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
  // theme: colors,
  theme: {
    themes: {
      light: lightColors,
      dark: darkColors,
    },
  },
};

export default new Vuetify(opts);
